import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationRefreshToken = gql`
  mutation refreshToken (
    $refreshToken: String!
  ) {
    refreshToken (
      refreshToken: $refreshToken
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;
export default mutationRefreshToken;
